import { render, staticRenderFns } from "./PartyBuilding.vue?vue&type=template&id=79bc0b0c&scoped=true"
import script from "./PartyBuilding.vue?vue&type=script&lang=js"
export * from "./PartyBuilding.vue?vue&type=script&lang=js"
import style0 from "./PartyBuilding.vue?vue&type=style&index=0&id=79bc0b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc0b0c",
  null
  
)

export default component.exports